export default __webpack_public_path__ + "static/media/BA.5b505932.png";